import { useLocalizedPriceFormatter } from 'tradera/localization/use-localized-price-formatter';
import { classNames } from 'tradera/utils/class-names';
import CheckFillIcon from 'tradera/blueprint/theme/icons2/check-fill.svg?jsx';
import { useAppSelector } from 'tradera/state/hooks';
import type { WishListItemCardViewModel } from 'tradera/state/services/types/webapi-member-generated';
import styles from './wish-list-share.module.scss';
import { CurrencyRateType } from 'tradera/state/multi-currency/reducer';
import { selectMemberAlias } from 'tradera/state/member/selectors';

type WishListShareItemProps = {
    item: WishListItemCardViewModel;
    isSelected: boolean;
    toggleItem: (item: WishListItemCardViewModel) => void;
};

export const WishListShareItem = ({
    item,
    isSelected,
    toggleItem
}: WishListShareItemProps) => {
    const memberAlias = useAppSelector(selectMemberAlias);
    const localizedPriceFormatter = useLocalizedPriceFormatter(
        item.sellerAlias === memberAlias
            ? CurrencyRateType.Seller
            : CurrencyRateType.Buyer
    );

    return (
        <button
            className={classNames(
                'position-relative unbutton',
                styles.wishListItem
            )}
            title={item.shortDescription}
            onClick={() => toggleItem(item)}>
            <div
                className={classNames({
                    [styles.wishListItemNotSelected]: !isSelected
                })}>
                {isSelected && (
                    <CheckFillIcon
                        className={classNames(
                            'icon icon-md bg-white',
                            styles.wishListItemSelected
                        )}
                    />
                )}
            </div>
            <img
                className={styles.wishListItemImage}
                loading="lazy"
                height={180}
                width={180}
                src={item.imageUrl.replace('/medium/', '/small-fit/')}
                title={item.shortDescription}
                alt={item.shortDescription}
            />
            <span
                className={classNames(
                    'text-white font-weight-bold text-styled',
                    styles.wishListItemPrice
                )}>
                {localizedPriceFormatter(item.price)}
            </span>
        </button>
    );
};
